export default function applyVoice(data, voiceData) {
    if (voiceData.contact_face) data.contact_face = voiceData.contact_face; 
    if (voiceData.sum) data.sum = voiceData.sum;
    if (voiceData.description) data.description = voiceData.description;
    return data;
}